/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>{{discountId?'编辑':'添加'}}{{contentType}}
      <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white box-shadow">
      <h4 class="p-3 text-left d-flex">基本信息
        <span class="text-link h6 font-weight-normal ml-auto" v-if="discountId>0 && $GFUN.isInArray([5,8],storeInfo.type)"
              @click="showEditMode=!showEditMode">{{showEditMode?'取消编辑':'编辑'}}</span>
      </h4>
      <div class="p-5">
        <div v-if="brand">
          <div v-if="!discountId || showEditMode" class="d-center-start mb-4">
              <left-text leftText="线路行程标签" required />
              <div class="d-center-start">
                <span v-for="(tag,index) in tagAddedArr" :key="index" class="tags"
                  :class="{btnactive: current == index}" @click="addClass(tag,index)">{{tag.tag}}</span>
                <el-input class="w-20 ml-2" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
                    size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" />
                <el-button v-else class="ml-4" size="mini" @click="showInput">自定义标签<i class="el-icon-edit ml-2"></i></el-button>
              </div>
          </div>
          <div v-else class="d-start-start mb-3 text-left">
            <left-text leftText="线路行程标签" required/>{{discountInfo.tag_name}}
          </div>
        </div>
        <div v-show="showEditMode">
          <left-text-border class="mb-3" :leftText="contentType + '标题'" v-model="discountInfo.title" required/>
          <left-text-border class="mb-3" :leftText="contentType + '内容'" v-model="discountInfo.content" required type="textarea"/>
        </div>
        <div v-show="!showEditMode">
          <div class="d-center-start mb-3">
            <left-text :leftText="contentType + '名称'" required/>{{discountInfo.title || discountInfo.name}}
          </div>
          <div class="d-start-start mb-3 text-left">
            <left-text :leftText="contentType + '内容'" required/>{{discountInfo.content}}
          </div>
        </div>
        <div class="d-start-start mb-3">
          <left-text :leftText="contentType + '相册'" required/>
          <upload-image @fileChange="(imgs)=>{this.discountInfo.pic = imgs;}"
                        :existImgs="discountInfo.pic" :maxLength="20" :editMode="showEditMode"/>
        </div>
        <el-button type="primary" @click="submitForm" v-show="showEditMode">提交</el-button>
        <el-button type="primary" @click="verify(discountId,'0')" v-show="showAdminVerify">审核通过</el-button>
        <activity-type-comp v-if="showActivityComp(5)" @verify="verify" />
        <package-type-comp v-if="showActivityComp(8)" :discountDetail="discountDetail"  @verify="verify" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import ActivityTypeComp from './activityTypeComp.vue'
  import PackageTypeComp from './packageTypeComp.vue'
  export default {
    name: 'addEditDiscount',
    components:{ActivityTypeComp,PackageTypeComp},
    data () {
      return {
        discountInfo: {
          pic:[]
        },
        showEditMode: false,
        inputVisible: false,
        inputValue: '',
        tagAddedArr:[],
        current: 0,
      }
    },
    computed: {
      ...mapState(['discountDetail']),
      ...mapGetters(['storeInfo','brand']),
      storeId () { return this.$route.query.store },
      discountId () { return this.$route.query.discount },
      contentType () { return this.brand ? '线路行程' : '活动' },
      showAdminVerify() {
        return this.storeInfo.type == 99 && !this.discountInfo.status;
      }
    },
    watch: {
      discountDetail () {
        this.discountInfo = { ...this.discountDetail };
        if (this.brand) {
          this.discountInfo.title = this.discountInfo.name
        }
        this.discountInfo.pic = this.discountInfo.pic ? this.discountInfo.pic.split(',') : [];
      },
      discountId(newVal) {
        if (newVal) this.showEditMode = false;
      },
      tagAddedArr (newVal) {
        if (!this.discountInfo.tag_id) this.discountInfo.tag_id = newVal[0].id
      }
    },
    async created() {
      //获取标签库及主线路行程
      if(this.brand) this.tagAddedArr = await this.getProductTags();
    },
    mounted () {
      this.UPDATECURRENTSTORE({ storeId: this.storeId })
      if (this.discountId) this.getDiscountDetail(this.discountId)
      else this.showEditMode = true;
    },
    destroyed () {
      this.UPDATECURRENTSTORE({ storeId: '' })
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getDiscountDetail', 'addEditDiscount','verifyItem','getProductTags','addTag']),
      showActivityComp(type) {
        let t = this.storeInfo.type,d = this.discountId;
        return (t == type && d > 0) || (t == 99 && this.discountInfo.status)
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
            this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      addClass(item,index){
        this.discountInfo.tag_id = item.id;
        this.current = index
      },
      handleInputConfirm() {
          let inputValue = this.inputValue;
          if (inputValue.includes(' ')) {
            this.$message.warning('标签名中请勿包含空格！')
            return
          }
          if (inputValue) {
            this.addTag({
              data: {tag:inputValue},
              successFun: res => {
                this.tagAddedArr.push({tag:inputValue,id:res.info});
                this.getProductTags()
              }
            })
          }
          this.inputVisible = false;
          this.inputValue = '';
      },
      validateForm() {
        if (!this.discountInfo.title) return {code:false,msg:`请填写${this.contentType}名称`}
        if (!this.discountInfo.content) return {code:false,msg:`请填写${this.contentType}内容`}
        if (this.discountInfo.pic.length <= 0) return {code:false,msg:`请上传${this.contentType}图片`}

        return {code:true,msg:'验证成功'}
      },
      submitForm () {
        let res = this.validateForm();
        if (res.code) {
          this._confirm('确认提交么？',async () => {
            this.discountInfo.pic = await UploadImages(this.discountInfo.pic);
            let pic = this.discountInfo.pic.join(',');
            if (this.brand) {
              this.discountInfo.store_type = 8
              this.discountInfo.name = this.discountInfo.title
              delete this.discountInfo.title
              if (this.discountId) this.discountInfo.itinerary_id = this.discountInfo.id
            }
            this.addEditDiscount({
              type: this.discountId ? 'edit' : 'add',
              data:{
                ...this.discountInfo,
                pic,
                homestay_onsale_id:this.discountInfo.id
              },
              successFun: _ => {this.showEditMode = false;this.$router.back(-1)}
            })
          })
        } else this._alert(res.msg,null,'error');
      },
      verify(id,type) {
        this._confirm('确认审核通过么？',() => {
          this.verifyItem({
            type:'homestayActi',
            data:{
              id,
              onsale_type:type
            },
            successFun:() => this.getDiscountDetail(this.discountId)
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.p-3{
  background-color: #fcfcfc!important;
  border-bottom: 1px solid #eee
}
.tags{
  height: 24px;
  line-height: 26px;
  border: 1px solid #eee;
  border-radius: 5px;
  margin-right: 12px;
  cursor: pointer;
  font-size: 13px;
  padding-left: 10px;
  padding-right: 10px
}
.btnactive{
  border: 1px solid var(--smtc-color-primary) !important;
  color: var(--smtc-color-primary); 
}
</style>